module.exports = __webpack_public_path__ + "assets/img/driver-btn-5dab27c3.png";